$ = jQuery;
$(document).ready(function () {




  $('[data-fancybox="form-newsletter"]').fancybox({
    baseClass: "form-newsletter-box"
  });

  var swiper = new Swiper('.photo-video-slider .swiper-container', {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1
      },
      640: {
        slidesPerView: 2
      }
    }
  });
  new Swiper('.donate-slider.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      }, 640: {
        slidesPerView: 1
      }
    }
  });


  $(".tab__content").hide();
  $(".tab__content:first").show();

  $(".tab__head li").click(function() {

    $(".tab__content").hide();
    var activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    $(".tab__head li").removeClass("active");
    $(this).addClass("active");
  });

  $('#open-review').click(function () {
    $(".tab__content").hide();
    var activeTab = $(this).attr("rel");
    $(".tab__head li").removeClass("active");
    $("#"+activeTab).fadeIn().addClass("active");
  });

  $('.accordion > li:eq(1) a').addClass('active').next().slideDown();

  $('.accordion a').click(function(j) {
    var dropDown = $(this).closest('li').find('div > div');

    $(this).closest('.accordion').find('div > div').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.accordion').find('a.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle();

    j.preventDefault();
  });
 
});

 



$(window).load(function () {
  $('.grid--isotope').isotope({
    itemSelector: '.grid-isotope',
    // percentPosition: true,
    masonry: {
      gutter: 20
    }
  });


 // setTimeout(function() { document.querySelector('#AddToCart.disabled').removeAttribute('disabled'); }, 1000);
   // $('#AddToCart.disabled').text('Out of stock').attr('data-fancybox','').attr('data-src','#out-stock-btn').fancybox();

});